import React, { ReactNode } from "react";
import './CFAdminModal.scss'
import CloseIcon from '../../assets/images/close.svg'

interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: () => void;
  isAdd?: boolean;
  title: string;
  modalBoxClassName?: string;
}

function CFAdminModal({ isAdd: _isAdd, ...props }: Readonly<ModalType>) {
  const modalBoxClassName = props.modalBoxClassName
    ? `modal-box ${props.modalBoxClassName}`
    : 'modal-box';

  return (
    <>
      {props.isOpen && (
        <div className="modal-overlay">
          <div className={modalBoxClassName}>
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">{props.title}</h3>
                <button type="button" className="modal-close" onClick={props.toggle} title="Cancel">
                  <img src={CloseIcon} alt="close" />
                </button>
              </div>
              <div className="modal-body">
                {props.children}
              </div>
             </div> 
          </div>
        </div>
      )}
    </>
  );
}

export default CFAdminModal;
